import { render, staticRenderFns } from "./ParagraphButton.vue?vue&type=template&id=764505c8&scoped=true&"
import script from "./ParagraphButton.vue?vue&type=script&lang=js&"
export * from "./ParagraphButton.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphButton.vue?vue&type=style&index=0&id=764505c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764505c8",
  null
  
)

export default component.exports